import { GRAB_AREA_MANAGEMENT_URL } from '../common/environment';
import {
  GrabAreaBatchSearchResult,
  GrabAreaGeoFence,
  GrabAreaHierarchyLayer,
  GrabAreaSearchResult,
} from './GrabAreaManagementDTOs';
import { trackError } from '@/services/configureAnalytics';
import { toQueryString } from '@/utils/url';

/** Represents a grab area management service ajax api. */
export class GrabAreaManagementService {
  /** The endpoint for the service. */
  private endpoint: string = GRAB_AREA_MANAGEMENT_URL;

  constructor(HttpService) {
    HttpService.addInterceptor(
      (response) => response,
      (error) => {
        const r = error.response || {
          status: undefined,
          data: undefined,
          statusText: undefined,
          config: { url: '' },
        };
        const data = r && r.data ? `${r.data.arg} ${r.data.devMessage}` : '';
        trackError(
          [
            error.config.method,
            error.config.url,
            data,
            r.status,
            r.statusText,
          ].join(' '),
        );
        return Promise.reject(error);
      },
    );
  }

  /** Get list of Grab Areas */
  getGrabAreas = async (params: {
    offset: number;
    limit: number;
    parentID?: number;
    areaName?: string;
    areaID?: number;
  }): Promise<GrabAreaSearchResult> => {
    const res = await fetch(
      `${this.endpoint}/grab-areas/summary${toQueryString(params)}`,
      {
        method: 'GET',
        headers: {
          'X-GrabKit-ClientID': 'grab-x',
        },
      },
    );
    return res.json();
  };

  /** Search list of Grab Areas by multiple area ids */
  batchSearchGrabArea = async (params: {
    limit: number;
    areaIDs: number[];
  }): Promise<GrabAreaBatchSearchResult> => {
    const res = await fetch(
      `${this.endpoint}/grab-areas/summary${toQueryString(params)}`,
      {
        method: 'GET',
        headers: {
          'X-GrabKit-ClientID': 'grab-x',
        },
      },
    );
    return res.json();
  };

  /** Get layers of Grab Area hierarchy */
  getGrabAreaHierarchy = async (params: {
    parentID: number;
  }): Promise<GrabAreaHierarchyLayer> => {
    const res = await fetch(
      `${this.endpoint}/grab-areas${toQueryString(params)}`,
      {
        method: 'GET',
        headers: {
          'X-GrabKit-ClientID': 'grab-x',
        },
      },
    );
    return res.json();
  };

  /** Get Grab Area GeoJson info */
  getGrabAreaGeoJson = async (params: {
    areaID: number;
  }): Promise<GrabAreaGeoFence> => {
    const res = await fetch(
      `${this.endpoint}/grab-areas/${params.areaID}/geojson`,
      {
        method: 'GET',
        headers: {
          'X-GrabKit-ClientID': 'grab-x',
        },
      },
    );
    return res.json();
  };
}
